<template>
  <div>
    <b-button v-b-modal.worker-stats>Статистика</b-button>
    <b-modal
      id="worker-stats"
      modal-class="fullSizeModal"
      :title="'Зарплата сотрудника ' + userIdentity.username"
      size="lg"
      ok-only>
      <date-filter :namespace="namespace"></date-filter>
      <WorkerStats :namespace="namespace" :role="userIdentity.role"></WorkerStats>
    </b-modal>
  </div>
</template>

<script>
import DateFilter from '../DateFilter'
import WorkerStats from '../WorkerStats'
import {callCenterGetters} from '../../constants/vuexGetters'
export default {
  name: 'WrapperWorkerStats',
  components: {
    WorkerStats,
    DateFilter
  },
  data () {
    return {
      namespace: 'callCenter/callCenterStats'
    }
  },
  computed: {
    userIdentity () {
      return {
        username: this.$userControl.jwtParsed ? this.$userControl.jwtParsed.name : '',
        role: this.$userControl.jwtParsed ? this.$userControl.jwtParsed.role : ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/WrapperWorkerStats.vue